import React from "react";
import GradientBorderElement from "../../../shared/gradientBorderElement/gradientBorderElement";
import { Divider } from "antd";
import { ReactComponent as DollarImage} from "../../../Images/ci/dollar-img.svg"
import { ReactComponent as SecurityImage} from "../../../Images/ci/security-img.svg"
import { capitalizeFirst } from "../../../utils/formatting";

import "./ciPolicyCostSummary.scss";

const CiPolicyCostSummary = ({ data = {} }) => {
    const { scanResultsSummary = {}, costResultsSummary = {} } = data;
    const beforeCost = costResultsSummary.cost?.before?.totalMonthlyCost || 0;
    const afterCost = costResultsSummary.cost?.after?.totalMonthlyCost || 0;
    const was = beforeCost == 0 ? beforeCost : parseFloat(beforeCost).toFixed(2);
    const now = afterCost == 0 ? afterCost : parseFloat(afterCost).toFixed(2);

    const severities = scanResultsSummary.rego?.notNoOpResourcesViolationsSeverityCount || {};
    const severitiesArr = [];
    // sort
    ["HIGH", "MEDIUM", "LOW"].forEach((key) => {
        const severity = severities[key] || 0;
        severitiesArr.push({ key: key.toLowerCase(), severityCount: severity });
    })

    return <GradientBorderElement content={
        <div className="CiPolicyCostSummary col">
            <SecurityImage className="CiPolicyCostSummary__securityImg" />
            <DollarImage className="CiPolicyCostSummary__dollarImg" />
        
            <div className="CiPolicyCostSummary__severity col g5">
            <div className="CiPolicyCostSummary__titleCont row">
                <span className="CiPolicyCostSummary__titleCont-text">Policy Violations</span>
            </div>
                {severitiesArr.map((severity = {}) => {
                    const { key, severityCount } = severity;
                    return (
                        <div className="row between" key={key}>
                            <span className="CiPolicyCostSummary__severity-text">{capitalizeFirst(key)}</span>
                            <span className={`CiPolicyCostSummary__severity-count ${key}`}>{severityCount}</span>
                        </div>
                    )
                })}
            </div>
            <Divider />
            <div className="CiPolicyCostSummary__titleCont row">
                <span className="CiPolicyCostSummary__titleCont-text">Cost Estimation</span>
            </div>
            <div className="row g8">
                <span className="CiPolicyCostSummary__cost">Was</span>
                <div className="row"> 
                    <span className="CiPolicyCostSummary__cost was">${was}</span>
                    <span className="CiPolicyCostSummary__cost-perMonth">/m</span>
                </div>
            </div>
            <div className="col">
                <span className="CiPolicyCostSummary__cost purple">Now</span>
                <div className="row">
                    <span className="CiPolicyCostSummary__cost purple now">${now}</span>
                    <span className="CiPolicyCostSummary__cost-perMonth purple">/m</span>
                </div>
            </div>
        </div>}/>;
};

export default CiPolicyCostSummary;